import ServiceEndpoints from "../ServiceEndpoints";
import {RequestsWithMetrics} from "../../model/RequestsWithMetrics";

export async function fetchIncomingRequests(activeRequestsForm: any, userToken: string | undefined, signal: AbortSignal): Promise<RequestsWithMetrics> {
    return await fetch(ServiceEndpoints.FetchIncomingRequests,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(activeRequestsForm),
            signal: signal
        })
        .then( async (resp) => {
            if (resp.ok) {
                return await resp.json() as RequestsWithMetrics;
            } else {
                return new RequestsWithMetrics();
            }
        })
        .catch((error) => {
            if (!signal.aborted) {
                console.error(error);
            }
            return new RequestsWithMetrics();
        });
}

export async function excelExportIncoming(activeRequestsForm: any, filename: string, userToken?: string): Promise<boolean> {
    return await fetch(ServiceEndpoints.ExportToExcelIncomingRequests,
        {
            method: 'post',
            headers: {"Content-Type": "application/json", "Authorization": "Bearer " + userToken},
            body: JSON.stringify(activeRequestsForm)
        })
        .then((resp) => {
            if(resp.ok) {
                return resp;
            }
            return undefined;
        })
        .then((response) => {
            if(response) {
                return response.blob();
            }
            return undefined;
        })
        .then((blob) => {
            if(blob) {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename + '.xlsx');
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.remove();
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}